module.exports = __webpack_public_path__ + "static/media/home.93faf4d4.svg";